
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/siriwat-kunaporn-joining",
      function () {
        return require("private-next-pages/blog/siriwat-kunaporn-joining.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/siriwat-kunaporn-joining"])
      });
    }
  